import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const prodConfig = {
  apiKey: 'AIzaSyBqjqzKuGFN0CO-Hgap3RSD0XsZlmoJAlg',
  authDomain: 'schedule-manager-59df5.firebaseapp.com',
  databaseURL: 'https://schedule-manager-59df5.firebaseio.com',
  projectId: 'schedule-manager-59df5',
  storageBucket: 'schedule-manager-59df5.appspot.com',
  messagingSenderId: '254210880868'
};

const devConfig = {
  apiKey: 'AIzaSyDd1tgPsyHGdcL9hGDKBWRuRgPXYknWO8g',
  authDomain: 'schedule-manager-dev.firebaseapp.com',
  databaseURL: 'https://schedule-manager-dev.firebaseio.com',
  projectId: 'schedule-manager-dev',
  storageBucket: '',
  messagingSenderId: '716042229916',
  appId: '1:716042229916:web:e48d6b2f2c5c71f0'
};

// Check to see if we're in dev mode (hot update = true)
if (window.webpackHotUpdate) {
  firebase.initializeApp(devConfig);
} else {
  firebase.initializeApp(prodConfig);
}

const db = firebase.firestore();
const auth = firebase.auth();

const CrewMembers = db.collection('CrewMembers');
const Positions = db.collection('Positions');
const Events = db.collection('Events');

export {
  db,
  auth,
  CrewMembers,
  Positions,
  Events
};
